import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  setInvisibleConfimPayJob,
  getConfirmJobs,
  fetchConfirmationPayStatus
} from 'src/reducers/employees/employeePays';
import { Close } from 'jbc-front/components/icons';
import { JobSuccess, JobFailed, JobInprogress } from 'src/components/JobStatus';
import { INITIAL_POLLING_INTERVAL, MAX_POLLING_INTERVAL } from 'src/constants/Generals';
import styles from './ConfirmationPayJobStatus.scss';

const TaskResult = ({ tasks, status, hideJobNotifications }) => {
  const { t } = useTranslation();
  let statusText = t('features.EmployeePays.components.ConfirmationPayJobStatus.salary_confirmed');
  let tasksStyle = styles.tasksSuccess;

  if (status === 'failed') {
    statusText = t('features.EmployeePays.components.ConfirmationPayJobStatus.salary_not_confirmed');
    tasksStyle = styles.tasksFailed;
  } else if (status === 'inProgress' || status === 'waiting') {
    statusText = t('features.EmployeePays.components.ConfirmationPayJobStatus.salary_in_confirming_process');
    tasksStyle = styles.tasksInprogress;
  }

  return (
    <React.Fragment>
      {tasks &&
        tasks.length > 0 && (
          <div className={tasksStyle}>
            <div className={styles.inner}>
              {status === 'success' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideJobNotifications(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {tasks.map(task => <JobSuccess key={task.id} {...task} statusText={statusText} />)}
                  </ul>
                </React.Fragment>
              )}
              {status === 'failed' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideJobNotifications(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {tasks.map(task => <JobFailed key={task.id} {...task} statusText={statusText} />)}
                  </ul>
                </React.Fragment>
              )}
              {(status === 'inProgress' || status === 'waiting') && (
                <React.Fragment>
                  <ul className={styles.list}>
                    {tasks.map(task => <JobInprogress key={task.id} {...task} statusText={statusText} />)}
                  </ul>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      {isEmpty(tasks) && null}
    </React.Fragment>
  );
};

class ConfirmationPayJobStatus extends React.Component {
  componentDidMount() {
    const { fetchVisibleConfirmPayJobs } = this.props;
    fetchVisibleConfirmPayJobs();
    this.pollFetchVisibleConfirmPayJobs(INITIAL_POLLING_INTERVAL);
  }

  pollFetchVisibleConfirmPayJobs = interval => {
    const { fetchVisibleConfirmPayJobs, confirmJobs } = this.props;
    let newInterval = interval;
    if (
      confirmJobs &&
      (Object.keys(confirmJobs).includes('inProgress') || Object.keys(confirmJobs).includes('waiting'))
    ) {
      fetchVisibleConfirmPayJobs();
      if (newInterval < MAX_POLLING_INTERVAL) {
        newInterval *= 2;
      }
    }
    setTimeout(this.pollFetchVisibleConfirmPayJobs, newInterval, newInterval);
  };

  render() {
    const { confirmJobs = {}, hideJobNotifications } = this.props;

    return (
      <React.Fragment>
        {isEmpty(confirmJobs) ? null : (
          <div>
            {Object.keys(confirmJobs).map(status => (
              <TaskResult
                key={status}
                tasks={confirmJobs[status]}
                status={status}
                hideJobNotifications={hideJobNotifications}
              />
            ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    confirmJobs: getConfirmJobs(state) || {}
  }),
  dispatch => ({
    fetchVisibleConfirmPayJobs: () => dispatch(fetchConfirmationPayStatus(true)),
    hideJobNotifications: tasks => {
      const taskIds = tasks.map(t => t.id).join('_');
      if (taskIds.length > 0) {
        dispatch(setInvisibleConfimPayJob(taskIds));
      }
    }
  })
)(ConfirmationPayJobStatus);
